import { rfqQuoteDetailsProposedDetailsGridStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsProposedDetailsGrid";
import { css } from "styled-components";



rfqQuoteDetailsProposedDetailsGridStyles.mainWrapper = {
    css: css`
        width: 100%;
        padding: 20px;
        background-color: white;
        box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.05);
        gap: 16px;
        margin-bottom: 10px;
    `,
};